import { IconButton, MenuItem, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ResupplyOrderSearchAutocomplete from "../../../../Components/ResupplyOrderSearchAutocomplete";
import Title from "../../../../Components/Title";

export default function ResupplyOrderSection({
  unedited,
  emaillist,
  setEmailList,
}) {
  unedited = unedited || emaillist;
  const { t } = useTranslation();
  const [resetKey, setResetKey] = useState("sdfasfsda");

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("emailLists.resupplys")}</Title>
      {unedited &&
        unedited.EmailListResupplyOrders &&
        unedited.EmailListResupplyOrders.map((u, i) =>
          u && u.ResupplyOrder ? (
            <MenuItem
              key={i}
              style={
                emaillist.EmailListResupplyOrders.find(
                  (uu) => uu.ResupplyOrder?.number === u.ResupplyOrder?.number
                )
                  ? {}
                  : { textDecoration: "line-through" }
              }
            >
              <Grid container direction="column">
                <Grid item>
                  <Typography style={{ fontSize: 15 }}>
                    {u.ResupplyOrder.number}
                  </Typography>
                </Grid>
                <Grid item container direction="row">
                  <Typography style={{ fontSize: 12 }}>
                    {u.ResupplyOrder.clientInfo?.companyName}
                  </Typography>
                  <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                    {" "}
                    {u.ResupplyOrder.clientInfo?.location}
                  </Typography>
                  <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                    {" "}
                    {u.ResupplyOrder.totalPrice} {u.ResupplyOrder.currency}
                  </Typography>
                </Grid>
              </Grid>
              <IconButton
                style={{ position: "absolute", right: 0 }}
                onClick={() => {
                  setEmailList({
                    ...emaillist,
                    EmailListResupplyOrders:
                      emaillist.EmailListResupplyOrders.filter(
                        (f) => f.ResupplyOrder?.id !== u.ResupplyOrder?.id
                      ),
                  });
                }}
              >
                <Clear />
              </IconButton>
            </MenuItem>
          ) : null
        )}
      {emaillist &&
        unedited &&
        emaillist.EmailListResupplyOrders &&
        emaillist.EmailListResupplyOrders.filter(
          (u) =>
            !unedited.EmailListResupplyOrders.length ||
            !unedited.EmailListResupplyOrders.find(
              (f) => u.ResupplyOrder?.id === f.ResupplyOrder?.id
            )
        ).map((u, i) => (
          <MenuItem
            key={i}
            style={{
              backgroundColor: "rgb(177 255 184)",
              fontSize: 15,
            }}
          >
            <Grid container direction="column">
              <Grid item>
                <Typography style={{ fontSize: 15 }}>
                  {u.ResupplyOrder.number}
                </Typography>
              </Grid>
              <Grid item container direction="row">
                <Typography style={{ fontSize: 12 }}>
                  {u.ResupplyOrder.clientInfo?.companyName}
                </Typography>
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {" "}
                  {u.ResupplyOrder.clientInfo?.location}
                </Typography>
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {" "}
                  {u.ResupplyOrder.totalPrice} {u.ResupplyOrder.currency}
                </Typography>
              </Grid>
            </Grid>
            <IconButton
              style={{ position: "absolute", right: 0 }}
              onClick={() => {
                setEmailList({
                  ...emaillist,
                  EmailListResupplyOrders:
                    emaillist.EmailListResupplyOrders.filter(
                      (f) => f.ResupplyOrder?.id !== u.ResupplyOrder?.id
                    ),
                });
              }}
            >
              <Clear />
            </IconButton>
          </MenuItem>
        ))}
      <ResupplyOrderSearchAutocomplete
        style={{ marginTop: 5 }}
        key={resetKey}
        additionalDataFields={[
          "clientInfo.companyName",
          "clientInfo.location",
          "totalPrice",
          "currency",
        ]}
        label={t("emailLists.searchOrder")}
        onChange={(e, v) => {
          if (!v || !v.number) {
            return;
          }
          setEmailList({
            ...emaillist,
            EmailListResupplyOrders: [
              ...(emaillist?.EmailListResupplyOrders || []),
              { ResupplyOrder: v },
            ],
          });
          setResetKey(new Date().toISOString());
        }}
      />
    </Grid>
  );
}
